// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__Xj2PM","gallerySliderMode":"style_gallerySliderMode__FvMHX","sliderContainer":"style_sliderContainer__lXVhL","slideItem":"style_slideItem__ykuG5"};